import { Mark } from "./Nav";
import { PRIVACY_URL, WAITLIST_URL, scrollToId } from "./data";

export const Footer = () => (
    <footer data-testid="site-footer" className="border-t border-[#262422] px-5 py-14 sm:px-8">
        <div className="mx-auto max-w-[1500px]">
            <div className="flex flex-col gap-10 sm:flex-row sm:items-start sm:justify-between">
                <div>
                    <div className="flex items-center gap-2.5">
                        <Mark size={18} />
                        <span className="text-sm font-semibold tracking-tight text-[#F4F1EC]">
                            DiscoveryProject
                        </span>
                    </div>
                    <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#8A8580]">
                        An early research project in social discovery. “Discovery” is a working
                        title. Mara is a fictional reference profile used to explore the product
                        concept.
                    </p>
                </div>
                <nav className="flex items-center gap-8" aria-label="Footer">
                    <a
                        href={PRIVACY_URL}
                        data-testid="footer-privacy-link"
                        className="nav-link text-sm text-[#C9C5C0] hover:text-[#F4F1EC]"
                    >
                        Privacy
                    </a>
                    <a
                        href={WAITLIST_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-waitlist-link"
                        className="nav-link text-sm text-[#C9C5C0] hover:text-[#F4F1EC]"
                    >
                        Join waitlist
                    </a>
                    <a
                        href="#top"
                        data-testid="footer-back-to-top"
                        onClick={(e) => scrollToId(e, "#top")}
                        className="nav-link text-sm text-[#C9C5C0] hover:text-[#F4F1EC]"
                    >
                        Back to top ↑
                    </a>
                </nav>
            </div>
            <p className="font-mono2 mt-12 text-[11px] uppercase tracking-[0.18em] text-[#8A8580]">
                People worth knowing · Real interests · Deeper connections
            </p>
        </div>
    </footer>
);
